import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import { ApplicationState } from "../store";
import CheckoutPageBottomLinkBase from "./CheckoutPageBottomLinkBase";

const CheckoutPageBottomLinks: React.FC<CheckoutPageBottomLinkProps> = (props: CheckoutPageBottomLinkProps) => {
  return (
    <CheckoutPageBottomLinkBase
      checkoutExtraUrl1={{
        link: props.confirmationLinks?.checkoutExtraUrl1?.link,
        urlText: props.confirmationLinks?.checkoutExtraUrl1?.urlText,
      }}
      checkoutExtraUrl2={{
        link: props.confirmationLinks?.checkoutExtraUrl2?.link,
        urlText: props.confirmationLinks?.checkoutExtraUrl2?.urlText,
      }}
    />
  );
};

const connector = connect((state: ApplicationState) => state.texts, {});

type CheckoutPageBottomLinkProps = ConnectedProps<typeof connector> & {};

export default connector(CheckoutPageBottomLinks);
